export default __webpack_public_path__ + "static/media/schema-bg.9358807a.svg";